/**
 * @fileoverview DELETE handler for the "/:app_group_id/conversational/tool_definition/:id" endpoint
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { conversationalToolDefinitionIdCacheKeys } from "./constants";
import type {
  DeleteConversationalToolDefinitionIdErrors,
  DeleteConversationalToolDefinitionIdProps,
} from "./types";

export const deleteConversationalToolDefinitionId = reactQueryMutationAdapter(
  conversationalToolDefinitionIdCacheKeys,
  createMutationFetcherFunctionWithShadowError<DeleteConversationalToolDefinitionIdErrors>()(
    (props: DeleteConversationalToolDefinitionIdProps): Promise<{}> => {
      return fetch(
        `/${props.appGroupId}/conversational/tool_definition/${props.definitionId}`,
        "DELETE",
        { type: props.type },
        undefined,
        {
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
